document.addEventListener('DOMContentLoaded', function() {
  customElements.define('custom-options', CustomOptions);
  customElements.define('upsell-product', UpsellOptions);

  let unit_conversion_buttons = document.querySelectorAll('.size-chart-table .unit-conversion input[type="radio"]');
  if(unit_conversion_buttons){
    unit_conversion_buttons.forEach(unit_btn => unit_btn.addEventListener('change', (event) => {
      event.preventDefault();
      event.stopPropagation();
      let container = document.querySelector('.size-chart-table.active');
      let tables = container.querySelectorAll('.main-table-block .size-table-wrapper .size-table');
      tables.forEach(table => {
        if(unit_btn.value == 'cm'){
          table.querySelectorAll('.size-table-cell').forEach(cell => {
            let cell_val = cell.innerHTML;
            if(cell_val && !isNaN(cell_val) && cell.classList.contains('in')){
              let converted_val = Math.round(cell_val * 2.54);
              cell.classList.add('cm');
              cell.classList.remove('in');
              cell.innerHTML = converted_val;
            }
          });
        }else{
          table.querySelectorAll('.size-table-cell').forEach(cell => {
            let cell_val = cell.innerHTML;
            if(cell_val && !isNaN(cell_val) && cell.classList.contains('cm')){
              let converted_val = cell.getAttribute('data-default');
              cell.classList.add('in');
              cell.classList.remove('cm');
              cell.innerHTML = converted_val;
            }
          });
        }
      });
    }));
  }

  let product_size_tab = document.querySelectorAll('.size-chart-table .product-size-tab-link');
  if(product_size_tab){
    product_size_tab.forEach(btn => btn.addEventListener('click', (event) => {
      event.preventDefault();
      let container = findAncestor (event.currentTarget, 'size-chart-table');
      container.querySelectorAll('.product-size-tab-link').forEach(el=>el.classList.remove("active"));
      container.querySelectorAll('.size-table-wrapper .size-table').forEach(el=>el.classList.remove("active"));
      event.currentTarget.classList.add("active");
      let data_type = event.currentTarget.getAttribute('data-type');
      document.querySelector('.size-chart--mask').classList.add("active");
      container.querySelector('.size-table-wrapper .size-table[data-type="'+ data_type +'"]').classList.add("active");
    }));
  }

  let size_chart_close_button = document.querySelectorAll('.size-chart-table .size-chart-close-button');
  if(size_chart_close_button){
    size_chart_close_button.forEach(btn => btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      btn.parentElement.classList.remove("active");
      document.querySelector('.size-chart--mask').classList.remove("active");
      if(!document.querySelector('.quick-add-popup.active')){
        let bodyScrollY = parseInt(document.body.style.getPropertyValue('top'), 10);
        bodyScrollY = Math.abs(bodyScrollY);
        document.body.classList.remove("fixed");
        document.body.style.top = null;
        window.scrollTo(0, bodyScrollY);
      }
    }));
  }
});
class CustomOptions extends HTMLElement {
  constructor() {
    super();
    this.container = this;
  }
  connectedCallback(){
    if(this.tagName.toLowerCase() == "custom-options" || this.tagName.toLowerCase() == "upsell-product"){
      this.getProductOptions();
    }
  }
  getProductOptions(){
    if(this.container.querySelector('.custom-options')){
    //GET OPTIONS
    this.product_id = this.getAttribute('data-product-id');
    this.product_type = this.getAttribute('data-product-type');
    let option_url = "/apps/app-proxy/product-options/" + this.product_id;
    let $this = this;
    fetch(option_url, {
      method: "GET"
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          $this.handleErrorMessage(response.description);
          return;
        }
        if(response.options.length == 0){
          //$this.querySelector('.total-additional-price').remove();
          //$this.querySelector('.additional-price').remove();
        }
        if($this.container.querySelector('.color-block')){
          $this.createFiltes(response);
          $this.createColors(response);
        }
        if($this.container.querySelector('.size-block')){
          $this.createSizes(response);
        }
        $this.createCustomize(response);
        $this.setReferencePrice();
        Currency.convertAll(theme.settings.defaultShopCurrency, getCookie("currentCurrency"));
        $this.changePrice();
        $this.initOptions();
        let first_customize_block = $this.container.querySelector('.customize-block-content .category-block:first-child .category-title');
        if(first_customize_block){
          first_customize_block.dispatchEvent(new Event('click'));
        }
        if($this.container.querySelector('.product-measurements.active') && !$this.container.querySelector('.product-size-options').classList.contains('active')){
          $this.container.querySelector('.product-measurements.active').dispatchEvent(new Event('click'));
        }
        if($this.container.querySelector('.product-size-options.active') && !$this.container.querySelector('.product-measurements').classList.contains('active')){
          $this.container.querySelector('.product-size-options.active').dispatchEvent(new Event('click'));
          $this.container.querySelector('.product-size-options.active').classList.add("hidden");
        }
        if($this.container.querySelector('.size-block.active') || $this.container.querySelector('.color-block.active')){
          $this.container.querySelectorAll('.product-form__btn').forEach(el=> el.classList.add("disabled") );
        }
        $this.container.querySelector('.product-form__buttons').classList.add('active');

        let pathName = decodeURIComponent(window.location.href);
        if (pathName.indexOf("?") !== -1 && pathName.indexOf("edit_id") !== -1) {
          let paramsParts = pathName.split("&");
          let edit_id;
          paramsParts.forEach(part => {
            if (part.indexOf("edit_id=") !== -1) {
              edit_id = part.split("edit_id=")[1];
            }
          });
          if(localStorage.getItem('custom_edit_' + edit_id)){
            var params = localStorage.getItem('custom_edit_' + edit_id);
            if(this.tagName.toLowerCase() == "custom-options"){
              $this.setParamValues(params);
            }
          }
        }

        if($this.container.querySelector('.product-spinner.active')){
          $this.container.querySelector('.product-spinner').classList.remove('active');
        }
        if($this.container.querySelector('.add-upsell-product')){
          $this.container.querySelector('.add-upsell-product').classList.add('active');
        }

        let category_button_block = $this.container.querySelector('.category-block.show .category-button-block .category-btn');
        if(category_button_block){
          category_button_block.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            let container = findAncestor (event.currentTarget, 'category-block');
            container.querySelectorAll('.customize-block-content-values .custom-option')[1].dispatchEvent(new Event('click'));
            container.querySelector('.category-button-block').classList.remove('active');
            container.querySelectorAll('.option-block').forEach(element => element.classList.add('active'));
            container.querySelector('.category-option-wrap').style.display = "block";
            container.querySelectorAll('.custom-option-wrap').forEach(element => element.style.display = "block");
            container.classList.add('active');
          })
        }

        let remove_vest = $this.container.querySelector('.category-block .remove-vest');
        if(remove_vest){
          remove_vest.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            let container = findAncestor (event.currentTarget, 'category-block');
            container.querySelector('.category-option-wrap').classList.remove('active');
            container.querySelectorAll('.customize-block-content-values').forEach((element) => {
              if(element.querySelectorAll('.custom-option')[0].classList.contains('checkbox-type') && element.querySelectorAll('.custom-option')[0].classList.contains('selected')){
                element.querySelectorAll('.custom-option')[0].dispatchEvent(new Event('click'));
              }else if(!element.querySelectorAll('.custom-option')[0].classList.contains('checkbox-type')){
                element.querySelectorAll('.custom-option')[0].dispatchEvent(new Event('click'));
              }
            });
            container.querySelectorAll('.option-block').forEach(element => element.classList.remove('active'));
            container.querySelector('.category-option-wrap').style.display = "none";
            container.querySelectorAll('.custom-option-wrap').forEach(element => element.style.display = "none");
            container.classList.remove('active');
            container.querySelector('.category-button-block').classList.add('active');
          })
        }

        if($this.container.querySelector('.filters-wrap-btn')){
          $this.container.querySelector('.filters-wrap-btn').addEventListener('click', (event) => {
            event.preventDefault();
            $this.container.querySelector('.filters-block').classList.add("active");
            if(!document.body.classList.contains('fixed')){
              $this.bodyFixed();
            }
          });
        }
        if($this.container.querySelector('.filters-mob-header .filters-mob-close-btn, .filters-btn .filters-result')){
          $this.container.querySelector('.filters-mob-header .filters-mob-close-btn, .filters-btn .filters-result').addEventListener('click', (event) => {
            event.preventDefault();
            $this.container.querySelector('.filters-block').classList.remove("active");
            //$this.bodyRemoveFixed();
          });
        }
        $this.stickyBtn();
      })
  }else{
      let sticky_elem = document.querySelector('.product__info-container--sticky');
      if(sticky_elem){
        if(document.querySelector('.sticky-header')){
          sticky_elem.style.top = (document.querySelector('.header-wrapper').offsetHeight + 10) + 'px';
        }else{
          sticky_elem.style.top = '15px';
        }
        this.stickyBtn();
        this.scrollProductInfo();
      }
    }

  }

  // CREATE SIZES POPUPS

  createSizes(data){
    let obj = data;
    obj.options.forEach((element) => {
      let option_values = '';
      let input_val;
      let option_block;
      let input_id;
      let image_elem;
      if(element.option_show_type == "size"){
        let value_id = element.option_id;
        let value_name = (element.display_name != '')? element.display_name : element.option_name;
        if (element.option_values) {
          element.option_values.forEach((val, i) => {
            let label_price = "<span class='size-price'></span>";
            let value_class = '';
            if(val.name.indexOf("Select") < 0 ){
              let price = '';
              if (val.price !== 0) {
                label_price = " (+<span class='price-with-custom-currency size-price-val' data-price='"+ val.price +"' data-currency='"+ theme.settings.defaultShopCurrency +"'>$"+ val.price +"</span>)";
                price = `($${val.price})`;
              }
              if(value_name.toLowerCase().indexOf("fit") != -1 || value_name.toLowerCase().indexOf("length") != -1){
                value_class = "text-val";
              }
              input_val = "<input class='hidden' name='properties["+ value_name.replace(':', '') +"]' type='radio' id='radioButton-"+ val.id +"' value='"+ val.name +" " + price  + "' data-price='"+ val.price +"'>";
              input_id = "<input class='hidden' name='properties[_option_"+ value_id +"]' id='radioButtonId-"+ val.id +"' type='radio' value='"+ val.id +"'>";
              var label = "<label class='check-option' data-price='" + val.price + "'>"+ val.name +"<span class='hide label-price'>"+ label_price +"</span></label>"
              option_values += "<div class='custom-option "+ value_class +"' data-price='"+ val.price +"'><div class='option-val'>" + input_id + input_val + label + "</div></div>";
              option_block = "<div class='option-block'><div class='option-block-title'>" + value_name + "<span class='size-price'></span></div><div class='custom-option-wrap'><div class='customize-block-content-values'>" + option_values + "</div></div></div>";
            }
          });
          if(this.product_type == "suits" && (element.option_group.toLowerCase() != 'suits') || this.product_type == "womens suit" && (element.option_group.toLowerCase() != 'womens suit') || this.product_type == 'waist coat & trouser set' ) {
            this.container.querySelector('.size-type-block[data-category="' + element.option_group.toLowerCase() + '"] .size-type-popup-content').innerHTML += option_block;
            this.container.querySelector('.size-type-block[data-category="' + element.option_group.toLowerCase() + '"]').classList.add("active");
          }else{
            this.container.querySelector('.size-type-block').classList.add("active");
            this.container.querySelector('.size-type-popup-content').innerHTML += option_block;
          }
          if(document.querySelector('.size-chart-table[data-product-type="' + element.option_group.toLowerCase() + '"]') && ! this.container.querySelector('.size-type-block[data-category="kids size"]') ){
            this.container.querySelector('.size-type-block[data-category="' + element.option_group.toLowerCase() + '"] .size-type-chart').classList.add("active");
          }else if(document.querySelector('.size-chart-table[data-product-type="kids size"]') && this.container.querySelector('.size-type-block[data-category="kids size"]')){
            this.container.querySelector('.size-type-block[data-category="kids size"] .size-type-chart').classList.add("active");
          }
        }
        this.container.querySelector('.product-size-options').classList.add("active");
        this.container.querySelector('.size-block').classList.add("active");
      }
    });
  }
  capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // CREATE CUSTOMIZE POPUP
  createCustomize(data) {
    let obj = data;
    let input_val;
    let option_block;
    let trouser_option_block;
    let jacket_option_block;
    let add_ons_option_block;
    let input_id;
    let customize_show = false;
    //Main Customizations
    obj.options.forEach((element) => {
      let option_values = '';
      if (element.option_show_type == "customize" && !element.option_set) {
        let value_id = element.option_id;
        let value_name = (element.display_name != '')? element.display_name : element.option_name;
        let max_length = '';
        let value_descr = "";
        let selected_var = "";
        let chacked_attr = "";
        let selected_attr = "";
        let selected_class = "";
        let text_label_price = "";
        if (element.option_values) {
          element.option_values.forEach((val, i) => {
            let label_price = "";
            let image_elem;
            let price = '';
            if(val.price !== 0){
              price = `($${val.price})`;
            }
            let price_type = val.price_type ? val.price_type : '';
            let price_ref_option_class = price_type != '' && price_type != 'fixed' ? ' reference_option_price ' : '';
            if (val.price !== 0 || val.price_type == 'waistcoat_reference_based') {
              label_price = " (+<span class='price-with-custom-currency' data-price='"+ val.price +"' data-currency='" + theme.settings.defaultShopCurrency + "'>$" + ((val.price / 100) * 100).toFixed(0) + "</span>)";
              text_label_price = "<label class='check-option text-label'>" + label_price + "</label>";
            }
            if (element.option_comment) {
              value_descr = "<div class='customize-block-content-description'>" + element.option_comment + "</div>";
            }
            chacked_attr = val.is_default ? 'checked' : '';
            selected_attr = val.is_default ? 'selected' : '';
            if (val.is_default) {
              selected_var = val.name + label_price;
              selected_class = 'selected';
            }
            if (element.max_length != 0) {
              max_length = element.max_length;
            }
            if (element.option_type_name == "Radio") {
              input_val = "<input class='option-info' data-option-name='" + val.name + " ' name='properties[" + value_name.replace(':', '') + "]' type='radio' " + chacked_attr + " id='radioButton-" + val.id + "' value='" + val.name + " " + price + "' data-price='" + val.price + "'>";
              input_id = "<input class='hidden' name='properties[_option_" + value_id + "]' id='radioButtonId-" + val.id + "' type='radio' " + chacked_attr + " value='" + val.id + "'>";
              var label = "<label class='check-option'>" + val.name + label_price + "</label>"
              if (val.image) {
                image_elem = "<div class='option-image'><img src='" + val.image + "'></div>";
              }
              option_values += "<div class='custom-option " + price_ref_option_class + selected_attr + "' data-reference-price='" + val.price + "' data-price-type='"+ price_type + "' data-price='" + val.price + "'>" + image_elem + "<div class='option-val'>" + input_id + input_val + label + "</div></div>";
            } else if (element.option_type_name == "Text" || element.option_type_name == "Textarea") {
              if (element.option_type_name == "Text") {
                input_val = "<input placeholder='" + element.placeholder + "' maxlength='" + max_length + "' class='text-option' type='text' value='' data-price='" + price + "'>" +
                  "<input class='text-option-prop hidden' name='properties[" + value_name.replace(':', '') + "]' type='text' value=''>";
                input_id = "<input class='hidden text-option-prop' name='properties[_option_" + value_id + "]' id='radioButtonId-" + val.id + "' type='text' value=''>"
              } else {
                input_val = "<textarea placeholder='" + element.placeholder + "'  maxlength='" + max_length + "' class='text-option' rows='4' name='properties[" + value_name.replace(':', '') + "]' type='text' value='' data-price='" + price + "'></textarea>" +
                  "<textarea class='text-option-prop hidden' rows='4' name='properties[" + value_name.replace(':', '') + "]' type='text' value=''></textarea>";
                input_id = "<textarea class='hidden text-option-prop' rows='4' name='properties[_option_" + value_id + "]' id='radioButtonId-" + val.id + "' type='text' value=''></textarea>"
              }
              option_values += "<div class='custom-option text-type " + price_ref_option_class + "' data-price='" + val.price + "' data-reference-price='" + val.price + "' data-price-type='"+ price_type + "'><div class='option-val'>" + input_id + input_val + text_label_price + "</div></div>";
            }  else if (element.option_type_name == "Checkbox") {
              let label = "<label class='check-option'>" + val.name + label_price + "</label>"
              input_val = "<input class='hidden option-info' data-option-name='" + val.name + "' name='properties[" + value_name.replace(':', '') + "]' data-option-id='" + val.id + "' type='checkbox' id='radioButton-" + val.id + "' value='" + val.name + " " + price + "'  " + chacked_attr + "  data-price='" + val.price + "'>";
              input_id = "<input  class='hidden' name='properties[_option_" + value_id + "]' id='radioButtonId-" + val.id + "' type='checkbox'  " + chacked_attr + "  value='" + val.id + "'>";
              option_values += "<div class='custom-option checkbox-type" + price_ref_option_class + selected_attr + "' data-reference-price='" + val.price + "' data-price-type='"+ price_type + "' data-price='" + val.price + "'><div class='option-val checkbox-type' >" + input_id + input_val + label + "</div></div>";
            }


          });
          if (element.option_group) {
            option_block = "<div class='option-block'><div class='option-block-title " + selected_class + "'>" + value_name + "<span class='selected-variant'>" + selected_var + "</span> <div class='plusminus'></div></div><div class='custom-option-wrap'>" + value_descr + "<div class='customize-block-content-values'>" + option_values + "</div></div></div>";
          } else {
            option_block = "<div class='option-block'><div class='category-option-wrap custom-option-wrap'>" + value_descr + "<div class='customize-block-content-values'>" + option_values + "</div></div></div>";
          }
          if (element.option_group && !element.option_set) {
            if (option_block) {
              if (this.product_type == "suits" || this.product_type == 'waist coat & trouser set' || this.product_type == "womens suit") {
                this.container.querySelector('.customize-block-popup .category-option-wrap[data-category="' + element.option_group.toLowerCase() + '"]').innerHTML += option_block;
                this.container.querySelector('.customize-block-popup .category-option-wrap[data-category="' + element.option_group.toLowerCase() + '"]').parentElement.classList.add("show");
              }else if(element.option_set == "addons"){
                this.container.querySelector('.customize-block-popup .category-option-wrap[data-category="add-ons"]').innerHTML += option_block;
                this.container.querySelector('.customize-block-popup .category-option-wrap[data-category="add-ons"]').parentElement.classList.add("show");
              } else {
                this.container.querySelector('.customize-block-popup .category-option-wrap:not(.addons)').innerHTML += option_block;
                this.container.querySelector('.customize-block-popup .category-option-wrap:not(.addons)').parentElement.classList.add("show");
              }

            }
            if(element.option_group.toLowerCase() == "waist coats"){
              let option_container = this.container.querySelector('.customize-block-popup .category-option-wrap[data-category="' + element.option_group.toLowerCase() + '"]');
              if(option_container.querySelectorAll('.custom-option')[1] && option_container.querySelectorAll('.custom-option')[1].querySelector('.price-with-custom-currency')){
                let option_price = option_container.querySelectorAll('.custom-option')[1].querySelector('.price-with-custom-currency').getAttribute('data-price');
                option_container.parentElement.querySelector('.category-button-block .category-button-price').innerHTML = '<span class="price-with-custom-currency" data-price="'+option_price+'" data-currency="' + theme.settings.defaultShopCurrency + '">$'+option_price+'</span>';
              }
              if(option_container.querySelectorAll('.custom-option')[0] && !option_container.querySelectorAll('.custom-option')[0].classList.contains('selected')){
                if(document.querySelector('.category-button-block.active')){
                  let container = document.querySelector('.category-button-block.active').parentElement;
                  container.querySelector('.category-button-block').classList.remove('active');
                  container.querySelector('.category-option-wrap').classList.add('active');
                }
              }
            }
          } else if (!element.option_group && !element.option_set) {
            let category_block = "<div class='category-block show'><div class='category-title'>" + value_name + "<div class='plusminus'></div></div>" + option_block + "</div>";
            if (option_block) {
              this.container.querySelector('.customize-block-content').innerHTML += category_block;
            }
          }
          customize_show = true;
        }
      }
    });
    if(customize_show){
      this.container.querySelector('.customize-block').classList.add("active");
      this.container.querySelector('.customize-info').checked = true;
      let input_val = "<input class='hidden'  name='properties[_has_options]' value='true'>";
      this.container.querySelector('.customize-block-content').innerHTML += input_val;
    }
    if(this.container.querySelector('.show-measure')){
      this.container.querySelector('.product-measurements').classList.add("active");
    }

    //Sets Customizations
    let option_sets = [];
    obj.options.forEach((element) => {
      if (element.option_show_type == "customize" && element.option_set) {
        option_sets.push(element.option_set);
      }
    });
    if (option_sets.length > 0) {
      option_sets = option_sets.filter((element, index) => {
        return option_sets.indexOf(element) === index;
      });
      option_sets.forEach((set) => {
        let set_title = this.capitalize(set).replaceAll('_', ' ');
        let option_set_values = '';
        let trouser_option_set_values = '';
        let jacket_option_set_values = '';
        let add_ons_option_set_values = '';
        let option_setOptions__info__wrapper = '';
        let trouser_option_setOptions__info__wrapper = '';
        let jacket_option_setOptions__info__wrapper = '';
        let option_set_block = '';
        let jacket_option_set_block = '';
        let trouser_option_set_block = '';
        let add_ons_option_set_block = '';

        if (set == "advance") {
          set_title = 'More customizations';
        }
        obj.options.forEach((element) => {
          let option_values = '';
          let trouser_option_values = '';
          let jacket_option_values = '';
          let add_ons_option_values = '';
          let info_div;
          let selected_var = '';
          let value_id = element.option_id;
          let value_name = (element.display_name != '')? element.display_name : element.option_name;
          let display = element.display;
          let value_descr = "";
          let active_class = '';
          let selected_attr = "";
          let selected_class = "";
          let max_length = '';
          let option_div;
          let text_label_price = '';
          let required_class = '';
          let required_class_info = '';
          let price_ref_class = element.is_used_for_reference_price ? ' reference_price ' : '';
          if (element.option_show_type == "customize" && element.option_set == set) {
            if (element.option_values) {
              element.option_values.forEach((val, i) => {
                let label_price = "";
                let image_elem = '';
                let price_type = val.price_type ? val.price_type : '';
                let price_ref_option_class = price_type != '' && price_type != 'fixed' ? ' reference_option_price ' : '';
                if(element.is_option_set_required_filed){
                  required_class = "required_set_option";
                  required_class_info = 'required_info'
                }
                //VALUE BLOCK
                let price = '';
                if (val.price !== 0) {
                  label_price = " (+<span class='price-with-custom-currency' data-price='"+ val.price +"' data-currency='" + theme.settings.defaultShopCurrency + "'>$" + ((val.price / 100) * 100).toFixed(0) + "</span>)";
                  text_label_price = "<label class='text-label'>" + label_price + "</label>";
                  price = `($${val.price})`;
                }
                let chacked_attr = val.is_default ? 'checked ' : '';
                let selected_attr = val.is_default ? 'selected ' : '';
                if (val.is_default) {
                  selected_var = '<span class="selected-variant">'+ val.name + label_price +'</span>';
                  selected_class = 'selected ';
                }
                if (val.image) {
                  image_elem = "<div class='option-image'><img src='" + val.image + "'></div>";
                }
                if (element.max_length != 0) {
                  max_length = element.max_length;
                }
                if (element.option_type_name == "Radio") {
                  input_val = "<input class='hidden option-info' data-option-name='" + val.name + "' name='properties[" + value_name.replace(':', '') + "]' data-option-id='" + val.id + "' data-color-code='" + val.color_code + "' type='radio'" + chacked_attr + "id='radioButton-" + val.id + "' value='" + val.name + " " + price + "' data-price='" + val.price + "'>";
                  input_id = "<input class='hidden'  name='properties[_option_" + value_id + "]' id='radioButtonId-" + val.id + "' type='radio'" + chacked_attr + "value='" + val.id + "'>";
                  if (display == "color_code") {
                    option_div = "<div class='custom-option is-colorable option_set " + price_ref_option_class + selected_attr + price_ref_class + "' data-option-id='" + val.id + "' data-price='" + val.price + "'><div class='hidden data-option-title'>" + val.name + label_price + "</div><div class='option-val' style='background-color: " + val.color_code + "'>" + input_id + input_val + "</div></div>";
                  }else if(display == 'text'){
                    option_div = "<div class='custom-option non-colorable only-text option_set " + price_ref_option_class + selected_attr + price_ref_class + "' data-option-id='" + val.id + "' data-price='" + val.price + "'><div class='data-option-title check-option'>" + val.name + label_price + "</div><div class='option-val'>" + input_id + input_val + "</div></div>";
                  }else if(display == 'image'){
                    option_div = "<div class='custom-option non-colorable option_set " + price_ref_option_class + selected_attr + price_ref_class + "' data-option-id='" + val.id + "' data-price='" + val.price + "'>" + image_elem + "<div class='data-option-title check-option hidden'>" + val.name + label_price + "</div><div class='option-val'>" + input_id + input_val + "</div></div>";
                  }
                  if (this.product_type == "suits" || this.product_type == 'waist coat & trouser set' || this.product_type == "womens suit") {
                    if (element.option_group == "Jackets") {
                      jacket_option_values += option_div;
                    } else if (element.option_group == "Trousers") {
                      trouser_option_values += option_div;
                    }
                  } else {
                    option_values += option_div;
                  }

                } else if (element.option_type_name == "Checkbox") {
                  let label = "<label class='check-option'>" + val.name + label_price + "</label>"
                  input_val = "<input class='hidden option-info' data-option-name='" + val.name + "' name='properties[" + value_name.replace(':', '') + "]' data-option-id='" + val.id + "' type='checkbox' id='radioButton-" + val.id + "' value='" + val.name + " " + price + "'  " + chacked_attr + "  data-price='" + val.price + "'>";
                  input_id = "<input  class='hidden' name='properties[_option_" + value_id + "]' id='radioButtonId-" + val.id + "' type='checkbox'  " + chacked_attr + "  value='" + val.id + "'>";
                  let option_div = "<div class='custom-option option_set " + price_ref_option_class + selected_attr + price_ref_class + "' data-reference-price='" + val.price + "' data-price-type='"+ price_type + "' data-option-id='" + val.id + "' data-price='" + val.price + "'><div class='option-val checkbox-type' >" + input_id + input_val + label + "</div></div>";
                  if (this.product_type == "suits" || this.product_type == 'waist coat & trouser set' || this.product_type == "womens suit") {
                    if (element.option_group == "Jackets") {
                      jacket_option_values += option_div;
                    } else if (element.option_group == "Trousers") {
                      trouser_option_values += option_div;
                    }else {
                      option_values += option_div;
                    }
                  } else if(set == "addons"){
                    add_ons_option_values += option_div;
                  }else {
                    option_values += option_div;
                  }
                } else if (element.option_type_name == "Text" || element.option_type_name == "Textarea") {
                  if (element.option_type_name == "Text") {
                    input_val = "<input placeholder='" + element.placeholder + "' maxlength='" + max_length + "' class='text-option' type='text' value='' data-price='" + price + "'>" +
                      "<input class='text-option-prop hidden' name='properties[" + value_name.replace(':', '') + "]' type='text' value=''>";
                    input_id = "<input class='hidden text-option-prop' name='properties[_option_" + value_id + "]' id='radioButtonId-" + val.id + "' type='text' value=''>"
                  } else {
                    input_val = "<textarea placeholder='" + element.placeholder + "' maxlength='" + max_length + "' class='text-option' rows='4'  ' value='' data-price=' " + price + "'></textarea>" +
                      "<textarea class='text-option-prop hidden' name='properties[" + value_name.replace(':', '') + "]'  ' value=''></textarea>";
                    input_id = "<textarea class='hidden text-option-prop' name='properties[_option_" + value_id + "]' id='radioButtonId-" + val.id + "' type='text' value=''></textarea>"
                  }
                  let option_div = "<div class='custom-option text-type" + price_ref_option_class + "' data-option-id='" + val.id + "' data-price='" + val.price + "' data-reference-price='" + val.price + "' data-price-type='"+ price_type + "'><div class='option-val'>" + input_id + input_val + text_label_price + "</div></div>";
                  if (this.product_type == "suits" || this.product_type == 'waist coat & trouser set' || this.product_type == "womens suit") {
                    if (element.option_group == "Jackets") {
                      jacket_option_values += option_div;
                    } else if (element.option_group == "Trousers") {
                      trouser_option_values += option_div;
                    }
                  } else {
                    option_values += option_div;
                  }
                }

                //INFO BLOCK
                if (element.option_comment) {
                  value_descr = element.option_comment;
                }
                if (val.image) {
                  image_elem = "<div class='option-image'><img src='" + val.image + "'></div>";
                }
                if (option_setOptions__info__wrapper == '') {
                  active_class = 'active';
                } else {
                  active_class = '';
                }
                var info_div = '<div class = "option_setOptions__info__wrapper ' + required_class_info + '" data-option-id="' + val.id + '">' +
                  '<div class="option_setOptions__info__thumbWrapper">' + image_elem + '</div>' +
                  '<div class = "option_setOptions__info__desc" >' +
                  '<div class = "option_setOptions__info__title" >' + value_name + '</div>' +
                  '<div class="advOptionInfo">' + value_descr + '</div>' +
                  '</div></div>';

                if (this.product_type == "suits" || this.product_type == 'waist coat & trouser set' || this.product_type == "womens suit") {
                  if (element.option_group == "Jackets") {
                    jacket_option_setOptions__info__wrapper += info_div;
                  } else if (element.option_group == "Trousers") {
                    trouser_option_setOptions__info__wrapper += info_div;
                  }else {
                    option_setOptions__info__wrapper += info_div;
                  }
                } else {
                  option_setOptions__info__wrapper += info_div;
                }

              });

              if (element.option_values.length == 1 && element.option_type_name != "Text" && element.option_type_name != "Textarea" ) {
                if (this.product_type == "suits" || this.product_type == 'waist coat & trouser set' || this.product_type == "womens suit") {
                  if (element.option_group == "Jackets") {
                    jacket_option_block = "<div class='option_setOptions__optionsList__item " + required_class + "'>" + jacket_option_values + "</div>";
                  } else if (element.option_group == "Trousers") {
                    trouser_option_block = "<div class='option_setOptions__optionsList__item " + required_class + "'>" + trouser_option_values + "</div>";
                  }else {
                    option_block = "<div class='option_setOptions__optionsList__item " + required_class + "'>" + option_values + "</div>";
                  }
                } else if(set == "addons"){
                  add_ons_option_block = "<div class='option_setOptions__optionsList__item " + required_class + "'>" + add_ons_option_values + "</div>";
                }else {
                  option_block = "<div class='option_setOptions__optionsList__item " + required_class + "'>" + option_values + "</div>";
                }
              } else {
                if (this.product_type == "suits" || this.product_type == 'waist coat & trouser set' || this.product_type == "womens suit") {
                  if (element.option_group == "Jackets") {
                    jacket_option_block = "<div class='option_setOptions__optionsList__item option-set " + required_class + selected_class + "'><div class='option-set-title'>" + value_name + selected_var + " <span class='selected-variant'>" + selected_var + "</span></div><div class='customize-block-content-values'>" + jacket_option_values + "</div></div>";
                  } else if (element.option_group == "Trousers") {
                    trouser_option_block = "<div class='option_setOptions__optionsList__item option-set " + required_class + selected_class + "'><div class='option-set-title'>" + value_name + selected_var + " <span class='selected-variant'>" + selected_var + "</span></div><div class='customize-block-content-values'>" + trouser_option_values + "</div></div>";
                  }else {
                    option_block = "<div class='option_setOptions__optionsList__item option-set " + required_class + selected_class + "'><div class='option-set-title'>" + value_name + selected_var + " <span class='selected-variant'></span></div><div class='customize-block-content-values'>" + option_values + "</div></div>";
                  }
                } else {
                  option_block = "<div class='option_setOptions__optionsList__item option-set " + required_class + selected_class + "'><div class='option-set-title'>" + value_name + selected_var + " <span class='selected-variant'></span></div><div class='customize-block-content-values'>" + option_values + "</div></div>";
                }
              }
            }

            if (this.product_type == "suits" || this.product_type == 'waist coat & trouser set' || this.product_type == "womens suit") {
              if (element.option_group == "Jackets") {
                jacket_option_set_values += jacket_option_block;
              } else if (element.option_group == "Trousers") {
                trouser_option_set_values += trouser_option_block;
              }else {
                option_set_values += option_block;
              }
            }else if(set == "addons"){
              add_ons_option_set_values += add_ons_option_block;
            } else {
              option_set_values += option_block;
            }
          }

        });
        let set__header = '';
        let jacket_header = '';
        let trouser_header = '';
        if (set == "advance") {
          if (this.product_type == "suits" || this.product_type == 'waist coat & trouser set' || this.product_type == "womens suit") {
            jacket_header = '<div class="option_set__header">Jackets Details</div>';
            set__header = '<div class="option_set__header">Trousers Details</div>';
          } else {
            set__header = '<div class="option_set__header">' + this.capitalize(this.product_type) + ' Details</div>';
          }
        }
        if (this.product_type == "suits" && set != "addons" || this.product_type == 'waist coat & trouser set' || this.product_type == "womens suit" && set != "addons") {
          jacket_option_set_block = '<div class="option_setOptions ">' +
            '<div class="option_setOptions__optionsList">' + jacket_header + jacket_option_set_values + '</div>' +
            '<div class = "option_setOptions__info" >' + jacket_option_setOptions__info__wrapper + '</div>'
          '</div>';
          trouser_option_set_block = '<div class="option_setOptions ">' +
            '<div class="option_setOptions__optionsList">' + trouser_header + trouser_option_set_values + '</div>' +
            '<div class = "option_setOptions__info" >' + trouser_option_setOptions__info__wrapper + '</div>'
          '</div>';

          if(jacket_option_set_values){
            this.container.querySelector('.category-option-wrap[data-category="jackets"]').innerHTML += "<div class='option-block'><div class='option-block-title'>" + set_title + "<div class='plusminus'></div></div><div class='custom-option-wrap'>" + jacket_option_set_block + "</div></div>";

          }
          if(trouser_option_set_values){
            this.container.querySelector('.category-option-wrap[data-category="trousers"]').innerHTML += "<div class='option-block'><div class='option-block-title'>" + set_title + "<div class='plusminus'></div></div><div class='custom-option-wrap'>" + trouser_option_set_block + "</div></div>";
          }
        }else if(this.product_type == "suits" && set == "addons" || this.product_type == "womens suit" && set == "addons" ) {
          let option_set_block = '<div class="option_setOptions ">' +
            '<div class="option_setOptions__optionsList">' + set__header + option_set_values + '</div>' +
            '<div class = "option_setOptions__info" >' + option_setOptions__info__wrapper + '</div>'
          '</div>';

          let category_block = "<div class='option-block addons'><div class='custom-option-wrap' data-set='"+ set +"'>" + option_set_block + "</div></div>";
          if(option_set_values){
            this.container.querySelector('.category-option-wrap[data-category="add-ons"]').innerHTML += category_block;
            this.container.querySelector('.category-option-wrap[data-category="add-ons"]').parentElement.classList.add('show');
          }
        }else if(set == "addons") {
          let add_ons_option_set_block = '<div class="option_setOptions ">' +
            '<div class="option_setOptions__optionsList">' + set__header + add_ons_option_set_values + '</div>' +
            '<div class = "option_setOptions__info" >' + option_setOptions__info__wrapper + '</div>'
          '</div>';

          let category_block = "<div class='option-block addons'><div class='custom-option-wrap' data-set='"+ set +"'>" + add_ons_option_set_block + "</div></div>";
          if(add_ons_option_set_values){
            this.container.querySelector('.category-option-wrap[data-category="add-ons"]').innerHTML += category_block;
            this.container.querySelector('.category-option-wrap[data-category="add-ons"]').parentElement.classList.add('show');
          }
        } else {
          option_set_block = '<div class="option_setOptions ">' +
            '<div class="option_setOptions__optionsList">' + set__header + option_set_values + '</div>' +
            '<div class = "option_setOptions__info" >' + option_setOptions__info__wrapper + '</div>'
          '</div>';

          let category_block = "<div class='option-block'><div class='option-block-title'>" + set_title + "<div class='plusminus'></div></div><div class='custom-option-wrap' data-set='"+ set +"'>" + option_set_block + "</div></div>";
          if(option_set_values){
            this.container.querySelector('.category-option-wrap[data-category="' + this.product_type + '"]').innerHTML += category_block;
          }
        }
        this.container.querySelectorAll('.option_setOptions__info').forEach(el =>{
          if(el.querySelector('.required_info')){
            el.querySelector('.required_info').classList.add("active");
          }else{
            el.querySelector('.option_setOptions__info__wrapper:first-child').classList.add("active");
          }
        });


      });

      let set_containers = this.container.querySelectorAll('.option_setOptions__optionsList');
      set_containers.forEach(container => {
        if(container.querySelector('.required_set_option')){
          container.querySelectorAll('.option_setOptions__optionsList__item:not(.required_set_option) .option-val input').forEach(el=>el.disabled = true);
        }
      });
    }
  }

// CREATE FABRIC POPUP
  createColors(data){
    let obj = data;
    obj.options.forEach((element) => {
      if(element.option_show_type == "fabric"){
        let option_values = '';
        let value_id = element.option_id;
        let value_name = (element.display_name != '')? element.display_name : element.option_name;
        let selected_var = "";
        let chacked_attr = "";
        let selected_attr = "";
        let selected_class = "";
        let btn_title = element.option_name;
        let price_ref_class = element.is_used_for_reference_price ? ' reference_price ' : '';
        if(element.option_values){
          if(this.container.querySelector('.product-colors-note')){
            this.container.querySelector('.product-colors-note').innerHTML = `<div class="product-colors-quantity">${element.option_values.length} ${element.option_values.length == 1 ? 'Color' : 'Colors' }</div>`;
          }
          element.option_values.forEach((val, i) => {
            let label_price = "";
            let input_val;
            let input_id;
            var image_elem = '';
            let create_date = new Date(val.updated_at.replace(/\-/g, '/'));
            let price = '';
            if(val.price != 0){
              label_price = " (+<span class='price-with-custom-currency' data-price='"+ val.price +"' data-currency='"+ theme.settings.defaultShopCurrency +"'>$"+ val.price +"</span>)";
              price = `($${val.price})`;
            }

            chacked_attr = val.is_default ? 'checked' : '';
            selected_attr = val.is_default ? 'selected' : '';
            if (val.is_default) {
              selected_var = val.name + label_price;
              selected_class = 'selected';
              if(value_name.toLowerCase().indexOf("fabric") > -1){
                btn_title = "Fabric Selected:  <span class='fabric-variant'>" + selected_var + "</span>";
              }else if(value_name.toLowerCase().indexOf("color") > -1){
                btn_title = "Color Selected:  <span class='fabric-variant'>" + selected_var + "</span>";
              }
            }
            input_val = "<input class='hidden' name='properties["+ value_name.replace(':', '') +"]' type='radio' " + chacked_attr + " id='radioButton-"+ val.id +"' value='"+ val.name +" " + price  + "' data-price='"+ val.price +"'>"
            input_id = "<input class='hidden' name='properties[_option_"+ value_id +"]' id='radioButtonId-"+ val.id +"' type='radio' " + chacked_attr + " value='"+ val.id +"'>"
            let label = "<label class='check-option'>"+ val.name + label_price +"</label>"
            if(val.image){
              image_elem = "<div class='option-image'><img src='"+ val.image +"'></div>";
            }
            option_values += "<div class='custom-option fabric " + selected_attr + price_ref_class + " ' data-option-name='" + value_name + "' data-price='"+ val.price +"' data-index='"+ i +"' data-date='"+ create_date.getTime() +"' data-filtr-attrs='"+ val.filters.join(';') +"'>"+ image_elem + "<div class='option-val'>" + input_id + input_val + label + "</div></div>";
          });
        }
        if(option_values.length > 1){
          this.container.querySelector('.color-block-btn').innerHTML = btn_title;
          this.container.querySelector('.color-popup-header .color-title').innerHTML = value_name;
          this.container.querySelector('.color-block-content').innerHTML = "<div class='option-block'>" + option_values + "</div>";
          this.container.querySelector('.color-block').classList.add("active");
          if(!selected_class == ''){
            this.container.querySelector('.color-block-btn').classList.add(selected_class);
            this.container.querySelector('.color-block').classList.add(selected_class);
          }
        }
      }
    });
  }

// FABRIC FILTERS

  createFiltes(data){
    let obj = data;
    let arrow = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="4px" height="9px" viewBox="0 0 4 9" version="1.1"><g id="UI-Design" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Homepage-(Tablet)" transform="translate(-691.000000, -6976.000000)" fill="#111111"><g id="Footer" transform="translate(0.000000, 6673.000000)"><g id="SHOPPING-Copy" transform="translate(56.000000, 283.000000)"><polygon id="Path-4-Copy-2" transform="translate(637.002747, 24.511819) rotate(-90.000000) translate(-637.002747, -24.511819) " points="632.490927 22.5090728 641.514566 22.5090728 636.945174 26.514566"/> </g></g></g></g></svg>';
    if(obj.filters.length > 0){
      let filter_field = '';
      obj.filters.forEach((filter) => {
        let filter_title = Object.keys(filter)[0];
        let filter_key = '';
        Object.values(filter)[0].forEach((value) => {
          filter_key += '<li class="filter-key" id="filter-value" title="'+ value +'" data-value="'+ value +'">'+ value +'</li>';
        });
        let filter_values = '<ul  class="filters-content" data-filter="'+ filter_title +'">'+ filter_key +'</ul>'
        filter_field += '<div class="filter-field"><div class="filter-title"><span>'+ filter_title +'<span class="filter-count"></span></span>'+ arrow +'</div>'+ filter_values +'</div>';
      });
      this.container.querySelector('#filters_bar').innerHTML += filter_field;
      fabricFilter.init(this.container.id);
      $('.filters-mob-btn').addClass('show');
      $('.filters-block').addClass('show');
    }
  };

  bodyFixed(){
    document.body.style.top = `-${window.scrollY}px`;
    document.body.classList.add('fixed');
  }
  bodyRemoveFixed(){
    let bodyScrollY = parseInt(document.body.style.getPropertyValue('top'), 10);
    bodyScrollY = Math.abs(bodyScrollY);
    document.body.classList.remove("fixed");
    document.body.style.top = null;
    window.scrollTo(0, bodyScrollY);
  }
  initOptions(){
    let sticky_elem = document.querySelector('.product__info-container--sticky');
    if(sticky_elem){
      if(document.querySelector('.sticky-header')){
        sticky_elem.style.top = (document.querySelector('.header-wrapper').offsetHeight + 10) + 'px';
      }else{
        sticky_elem.style.top = '15px';
      }

      this.scrollProductInfo();
    }
    /**
     * This function allows to automatically scrolls within a div when this div does not fit into the visible space
     */
    let size_btn = this.container.querySelectorAll('.size-block-btn');
    if(size_btn){
      size_btn.forEach(btn => btn.addEventListener('click', (event) => {
        event.preventDefault();
        if(!event.currentTarget.classList.contains('selected')){
          let content_type = event.currentTarget.getAttribute('data-content');
          event.currentTarget.classList.add("selected");
          this.container.querySelector('.size-block').classList.remove("selected");
          this.container.querySelectorAll('.size-block-btn').forEach(el=>el.classList.remove("selected"));
          this.container.querySelectorAll('.size-type-block').forEach(el=>el.classList.remove("selected"));
          this.container.querySelectorAll('.size-block .content-type').forEach(el=>el.classList.remove("active", 'selected'));
          this.container.querySelectorAll('.size-block .custom-option').forEach(el=>el.classList.remove("selected-variant", 'selected'));
          this.container.querySelectorAll('.size-block .custom-option').forEach(el=>el.classList.remove("selected-variant", 'selected'));
          this.container.querySelectorAll('.size-block .size-val').forEach(el=>el.innerHTML = '');
          this.container.querySelectorAll('.size-block .size-price').forEach(el=>el.innerHTML = '');
          this.container.querySelector('.content-type[data-content="'+ content_type +'"]').classList.add("active");
          this.container.querySelector('.size-block-btn[data-content="'+ content_type +'"]').classList.add("selected");
          this.container.querySelector('.size-block').querySelectorAll('input').forEach(el=>el.checked = false);
          this.container.querySelector('.content-type[data-content="'+ content_type +'"]').querySelector('.measure-type').checked = true;
          if(content_type == 'measure-note'){
            this.container.querySelector('.content-type[data-content="'+ content_type +'"]').classList.add("selected");
          }
          if(this.container.querySelector('.content-type.active').classList.contains('selected')){
            findAncestor (btn, 'required-block').classList.add("selected");
          }
          findAncestor (btn, 'required-block').classList.add("select");
          this.changePrice();
          this.checkRequired();
        }
      }));
    }

    let size_type = this.container.querySelectorAll('.size-type-block');
    if(size_type){
      size_type.forEach(btn => btn.addEventListener('click', (event) => {
        event.preventDefault();
        this.container.querySelectorAll('.size-type-popup').forEach(el=>el.classList.remove("active"));
        btn.querySelector('.size-type-popup').classList.add("active");
      }));
    }

    let size_type_chart = this.container.querySelectorAll('.size-type-chart');
    if(size_type_chart){
      size_type_chart.forEach(btn => btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        let data_type = btn.parentElement.getAttribute('data-category');
        document.querySelector('.size-chart-table[data-product-type="'+ data_type +'"]').classList.add("active");
        document.querySelector('.size-chart--mask').classList.add("active");
        if(!document.body.classList.contains('fixed')){
          this.bodyFixed();
        }
      }));
    }

    let close_button = this.container.querySelectorAll('.close-button');
    if(close_button){
      close_button.forEach(btn => btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if(findAncestor (btn, 'option-popup')){
          findAncestor (btn, 'option-popup').classList.remove("active");
          this.closePopup();
        }
      }));
    }

    let close_size_buttons = this.container.querySelectorAll('.close-size-button');
    if(close_size_buttons){
      close_size_buttons.forEach(btn => btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if(findAncestor (btn, 'option-popup')){
          findAncestor (btn, 'option-popup').classList.remove("active");
        }
      }));
    }
    let apply_button = this.container.querySelectorAll('.apply-button');
    if(apply_button){
      apply_button.forEach(btn => btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        let cur_size = '';
        let apply_val = false;
        if( event.currentTarget.parentElement.classList.contains('size-type-popup')) {
          event.currentTarget.parentElement.querySelectorAll('.custom-option.selected').forEach(el => {
            if(cur_size != ''){
              cur_size += ',' + el.querySelector('label').innerHTML;
            }else{
              cur_size += el.querySelector('label').innerHTML;
            }
          });
          if(event.currentTarget.parentElement.querySelectorAll('.option-block').length == event.currentTarget.parentElement.querySelectorAll('.custom-option.selected').length){
            let size_block = findAncestor (event.currentTarget, 'size-type-block');
            size_block.querySelector('.size-val').innerHTML = cur_size;
            size_block.classList.add('selected');
            this.changePrice();
          }
        }
        if(event.currentTarget.parentElement.querySelectorAll('.option-block').length == event.currentTarget.parentElement.querySelectorAll('.custom-option.selected').length){
          apply_val = true;
        }
        if(apply_val){
          event.currentTarget.parentElement.querySelector('.note-error').classList.remove("active");
          findAncestor (btn, 'option-popup').classList.remove("active");
          if(!event.currentTarget.parentElement.classList.contains('size-type-popup')){
            this.closePopup();
          }
          this.checkSizes();
          this.checkRequired();
        }else{
          event.currentTarget.parentElement.querySelector('.note-error').classList.add("active");
        }

      }));
    }

    let check_option = this.container.querySelectorAll('.custom-option:not(.option_set):not(.text-type)');
    if(check_option){
      check_option.forEach(btn => btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        let parent = findAncestor (btn, 'option-block');
        let container = findAncestor(parent, 'category-option-wrap');
        let category_type;
        if(container){
          category_type = container.getAttribute('data-category');
          if(!event.currentTarget.classList.contains('checkbox-type') || category_type != "waist coats") {
            parent.querySelectorAll('input').forEach(el=>el.checked = false);
            parent.querySelectorAll('.custom-option').forEach(el => el.classList.remove("selected"));
            event.currentTarget.querySelectorAll('input').forEach(el=>el.checked = true);
            event.currentTarget.classList.add("selected", "selected-variant");
          }else if(event.currentTarget.classList.contains('checkbox-type') && category_type == "waist coats"){
            event.currentTarget.querySelectorAll('input[type="checkbox"]').forEach( el => el.checked = el.checked ? false : true);
            event.currentTarget.classList.toggle("selected");
          }
        }else{
          parent.querySelectorAll('input').forEach(el=>el.checked = false);
          parent.querySelectorAll('.custom-option').forEach(el => el.classList.remove("selected"));
          event.currentTarget.querySelectorAll('input').forEach(el=>el.checked = true);
          event.currentTarget.classList.add("selected", "selected-variant");
        }

        if( findAncestor (event.currentTarget, 'option-block').parentElement.classList.contains('size-type-popup-content')) {
          if(event.currentTarget.querySelector('.check-option .size-price-val')){
            parent.querySelector('.size-price').innerHTML = event.currentTarget.querySelector('.check-option .label-price').innerHTML;
          }else{
            parent.querySelector('.size-price').innerHTML = '';
          }
        }else if(event.currentTarget.classList.contains('checkbox-type') && !event.currentTarget.classList.contains('selected')){
          parent.querySelector('.option-block-title .selected-variant').innerHTML = '';
          parent.querySelector('.option-block-title').classList.remove("selected");
        }else if(parent.querySelector('.option-block-title .selected-variant')){
          let val = event.currentTarget.querySelector('.check-option').innerHTML;
          parent.querySelector('.option-block-title .selected-variant').innerHTML = val;
          parent.querySelector('.option-block-title').classList.add("selected");
        }else if(event.currentTarget.classList.contains('fabric')){
          if(event.currentTarget.getAttribute('data-option-name').toLowerCase().indexOf("fabric") > -1){
            this.container.querySelector('.color-block-btn').innerHTML = "Fabric Selected:  <span class='fabric-variant'>" + event.currentTarget.querySelector('.check-option').innerHTML + "</span>";
          }else if(event.currentTarget.getAttribute('data-option-name').toLowerCase().indexOf("color") > -1){
            this.container.querySelector('.color-block-btn').innerHTML = "Color Selected:  <span class='fabric-variant'>" + event.currentTarget.querySelector('.check-option').innerHTML + "</span>";
          }
          this.container.querySelector('.color-block-btn').classList.add("selected");
          if(!findAncestor(event.currentTarget, 'required-block').classList.contains('selected')){
            findAncestor(event.currentTarget, 'required-block').classList.add('selected');
            this.checkRequired();
          }
          this.setReferencePrice();
        }
        if(category_type == "waist coats" && parent.querySelectorAll('.custom-option')[0] == event.currentTarget && container.firstChild == parent ){
          if(parent.nextElementSibling){
            parent.nextElementSibling.classList.add('hidden');
          }
          container.querySelectorAll('.customize-block-content-values').forEach((element) => {
            if(element.querySelectorAll('.custom-option')[0].classList.contains('checkbox-type') && element.querySelectorAll('.custom-option')[0].classList.contains('selected')){
              element.querySelectorAll('.custom-option')[0].dispatchEvent(new Event('click'));
            }
          });
        }else if(category_type == "waist coats" && parent.querySelectorAll('.custom-option')[0] != event.currentTarget && container.firstChild == parent && parent.nextElementSibling){
          parent.nextElementSibling.classList.remove('hidden');
        }
        if( !findAncestor (event.currentTarget, 'option-block').parentElement.classList.contains('size-type-popup-content')){
          this.changePrice();
        }

      }));
    }

    let option_set_check_option = this.container.querySelectorAll('.option_setOptions .custom-option:not(.text-type)');
    if(option_set_check_option){
      option_set_check_option.forEach(btn => btn.addEventListener('click', (event) => {
        event.preventDefault();
        if(!findAncestor (event.currentTarget, 'option_setOptions').querySelector('.required_info')){
          this.changeOptionInfo(event);
        }
        let parent = findAncestor (btn, 'option_setOptions__optionsList__item');
        if(parent.classList.contains('option-set')){
          parent.querySelectorAll('input').forEach(el=>el.checked = false);
          parent.querySelectorAll('.custom-option').forEach(el=>el.classList.remove("selected"));
          event.currentTarget.querySelectorAll('input').forEach(el=>el.checked = true);
          event.currentTarget.classList.add("selected");
          let val = event.currentTarget.querySelector('.data-option-title').innerHTML;
          parent.querySelector('.selected-variant').innerHTML = val;
        }else{
          event.currentTarget.querySelectorAll('input[type="checkbox"]').forEach(el=>el.checked = !el.checked);
          event.currentTarget.classList.toggle("selected");
        }
        this.changePrice();
      }));
    }
    let hover_set_check_option = this.container.querySelectorAll('.option_setOptions');
    if(hover_set_check_option){
      hover_set_check_option.forEach(el =>{
        if(!el.querySelector('.required_info')){
          el.querySelectorAll('.custom-option').forEach(btn => btn.addEventListener('mouseenter', this.changeOptionInfo));
        }
      });

    }

    let set_inputs = this.container.querySelectorAll('.option_setOptions__optionsList__item.required_set_option input');
    set_inputs.forEach(input => input.addEventListener('input', (event) => {
      if(input.value.length > 0){
        findAncestor (input, 'option_setOptions__optionsList').querySelectorAll('.option_setOptions__optionsList__item:not(.required_set_option) .option-val input').forEach(el=>el.disabled = false);
      }else{
        findAncestor (input, 'option_setOptions__optionsList').querySelectorAll('.option_setOptions__optionsList__item:not(.required_set_option) .option-val input[type="text"]').forEach(el=>el.value = '');
        findAncestor (input, 'option_setOptions__optionsList').querySelectorAll('.option_setOptions__optionsList__item:not(.required_set_option) .option-val input').forEach(el=>el.disabled = true);
      }
    }));

    let text_option = this.container.querySelectorAll('.text-option');
    if(text_option){

      text_option.forEach(input => input.addEventListener('change', (event) => {
        event.preventDefault();
        let parent;
        if(findAncestor (input, 'option_setOptions__optionsList__item')){
          parent = findAncestor (input, 'option_setOptions__optionsList__item');
        }else{
          parent = findAncestor (input, 'option-block');
        }
        if(input.value.length > 0){
          if(parent.querySelector('.text-label')){
            let val = parent.querySelector('.text-label').innerHTML;
            if(parent.querySelector('.option-block-title')){
              parent.querySelector('.option-block-title .selected-variant').innerHTML = input.value + val;
              parent.querySelector('.option-block-title').classList.add("selected");
            }
            parent.classList.add("selected", "selected-variant");
            parent.querySelector('.custom-option').classList.add("selected");
            parent.querySelectorAll('.text-option-prop').forEach(el=>el.value  = input.value + " " + input.getAttribute('data-price'));
          }else{
            parent.querySelectorAll('.text-option-prop').forEach(el=>el.value  = input.value);
          }
        }else{
          parent.querySelectorAll('.text-option-prop').forEach(el=>el.value  = '');
          if(parent.querySelector('.option-block-title .selected-variant')){
            parent.querySelector('.option-block-title .selected-variant').innerHTML = "";
            parent.querySelector('.option-block-title').classList.remove("selected");
          }
          parent.classList.remove("selected", "selected-variant");
          parent.querySelector('.custom-option').classList.remove("selected");
        }
        this.changePrice();
      }));
    }

    let open_option_popup = this.container.querySelector('.customize-block-btn');
    open_option_popup.addEventListener('click', (event) => {
      event.preventDefault();
      this.container.querySelector('.customize-block-popup').classList.add("active");
      document.querySelector('.option-mask').classList.add("active");
      if(!document.body.classList.contains('fixed')){
        this.bodyFixed();
      }
      if(document.querySelector('.product__info-container--sticky')){
        document.querySelector('.product__info-container--sticky').classList.add("not-sticky");
      }
    });

    let color_option_popup = this.container.querySelector('.color-block-btn');
    color_option_popup.addEventListener('click', (event) => {
      event.preventDefault();
      this.container.querySelector('.color-block-popup').classList.add("active");
      document.querySelector('.option-mask').classList.add("active");
      if(!document.body.classList.contains('fixed')){
        this.bodyFixed();
      }
      if(document.querySelector('.product__info-container--sticky')){
        document.querySelector('.product__info-container--sticky').classList.add("not-sticky");
      }
    });

    let container_id = this.container.id;

    $('#'+ container_id +' .category-title').on('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      $(this).parent().toggleClass("active");
      if($(this).parent().hasClass('active')){
        $(this).parent().find('.category-option-wrap').slideDown(400);
      }else{
        $(this).parent().find('.category-option-wrap').slideUp(400);
        $(this).parent().find('.option-block').removeClass('active');
        $(this).parent().find('.custom-option-wrap').slideUp(400);
      }
    });

    $('#'+ container_id +' .option-block-title').on('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      $(this).parent().toggleClass("active");
      if($(this).parent().hasClass('active')){
        $(this).parent().find('.custom-option-wrap').slideDown(400);
      }else{
        $(this).parent().find('.custom-option-wrap').slideUp(400);
      }
    });

    let btn_disabled = this.container.querySelectorAll('.product-form__btn_disabled');
    if(btn_disabled){
      btn_disabled.forEach(btn => btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        btn.parentElement.classList.add("error");
        btn.innerHTML = "make a seleсtion";
        this.container.querySelectorAll('.required-block:not(.selected)').forEach((el, i) => {
          if(!el.classList.contains('select')){
            el.querySelectorAll('.options-btn').forEach(el=>el.classList.add("error"));
          }
          el.parentElement.querySelectorAll('.required-child:not(.selected) .size-type-btn').forEach(el=>el.classList.add("error"));
        });
        if(document.querySelector('.product-form__buttons.fixed')){
          let sticky_header = 0;
          let option_block = findAncestor (this.container.querySelectorAll('.options-btn.error')[0], 'custom-options');
          if(document.querySelector('.sticky-header')){
            sticky_header = +document.querySelector('.header-wrapper').offsetHeight;
          }
          window.scrollTo({top: (option_block.offsetTop - sticky_header - 20 ) , behavior: 'smooth'});
        }
      }));
    }
    let add_upsell_product = this.container.querySelectorAll('.add-upsell-product');
    if(add_upsell_product){
      add_upsell_product.forEach(btn => btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        btn.classList.remove('active');
        btn.parentElement.querySelector('.product-form-wrap').classList.add("active");
      }));
    }
  }
  changeOptionInfo(event){
    let option_set_block = findAncestor (event.currentTarget, 'option_setOptions');
    let option_id = event.currentTarget.getAttribute('data-option-id');
    option_set_block.querySelectorAll('.option_setOptions__info__wrapper').forEach(el=>el.classList.remove("active"));
    option_set_block.querySelector('.option_setOptions__info__wrapper[data-option-id="' + option_id + '"]').classList.add("active")
  }
  checkRequired(){
    this.container.querySelectorAll('.required-block.active').forEach((el, i) => {
      el.querySelectorAll('.options-btn').forEach(el=>el.classList.remove("error"));
      el.querySelectorAll('.required-child .size-type-btn').forEach(el=>el.classList.remove("error"));
    });
    this.container.querySelectorAll('.product-form__btn_disabled').forEach(el=>el.innerHTML = '');
    if(this.container.querySelectorAll('.required-block.active:not(.selected)').length > 0){
      this.container.querySelectorAll('.product-form__btn').forEach(el=>{el.classList.remove( "error"); el.classList.add( "disabled")});
    }else{
      this.container.querySelectorAll('.product-form__btn').forEach(el=>el.classList.remove( "disabled", "error"));
    }

  }
  checkSizes(){
    this.container.querySelectorAll('.size-type-wrap .size-type-block').forEach(el=> {
      let option_length = el.querySelectorAll('.option-block').length;
      let option_checked_length = 0;
      el.querySelectorAll('.custom-option.selected-variant').forEach(el=> {
        option_checked_length++;
      });
    });
    if(this.container.querySelectorAll('.size-type-wrap .size-type-block').length == this.container.querySelectorAll('.size-type-wrap .size-type-block.selected').length){
      this.container.querySelector('.size-block').classList.add('selected');
    }
  }
  changePrice(){
    let current_cur;
    let current_price;
    let price__compare;
    let additional_price = 0;
    this.container.querySelectorAll('.custom-option.selected').forEach(el=> {
      additional_price += +parseInt(el.querySelector(".option-val input[data-price]").getAttribute('data-price').trim().replace('.00', "").replace(/[^0-9]/g, ""));
    });
    if(this.container.querySelector('.total-additional-price')){
      this.container.querySelector('.additional-price').value = additional_price;
      this.container.querySelector('.total-additional-price').value = additional_price;
    }

    if(this.container.querySelector('.price-block .price').classList.contains('price--on-sale')){
      current_cur = this.container.querySelector('.price-block .price__sale .price-item--regular').getAttribute('data-currency');
      current_price = +this.container.querySelector('.price-block .price__sale .price-item--regular').getAttribute('data-currency-'+ current_cur.toLowerCase()).replace(/[^0-9]/g, "");
      price__compare = +this.container.querySelector('.price-block .price__sale .price-item--sale').getAttribute('data-currency-'+ current_cur.toLowerCase()).replace(/[^0-9]/g, "");

      let new_price = current_price;
      let new_price__compare = price__compare;

      this.container.querySelectorAll('.custom-option.selected').forEach(el=> {
        if(el.querySelector(".price-with-custom-currency")){
          new_price += +(el.querySelector(".price-with-custom-currency").innerHTML.replace(/[^0-9]/g, ""));
          new_price__compare += +(el.querySelector(".price-with-custom-currency").innerHTML.replace(/[^0-9]/g, ""));
        }
      });

      let cur = document.querySelector('.multi-picker__label').innerHTML;
      let p_price = Currency.convert(new_price, cur, cur) * 100;
      let p_price_compare = Currency.convert(new_price__compare, cur, cur) * 100;
      let u = Currency.money_format[cur] || "{{amount}}";
      let r = Currency.formatMoney(p_price, u);
      let r_compare = Currency.formatMoney(p_price_compare, u);

      this.container.querySelectorAll('.product .price-with-custom-currency.price-item--regular').forEach(el=> el.innerHTML = r);
      this.container.querySelectorAll('.product .price-with-custom-currency.price-item--sale').forEach(el=> el.innerHTML = r_compare);
    }else{
      current_cur = this.container.querySelector('.price-block .price__regular .price-item--regular').getAttribute('data-currency');
      current_price = +this.container.querySelector('.price-block .price__regular .price-item--regular').getAttribute('data-currency-'+ current_cur.toLowerCase()).replace(/[^0-9]/g, "");
      let new_price = current_price;
      this.container.querySelectorAll('.custom-option.selected').forEach(el=> {
        if(el.querySelector(".price-with-custom-currency")){
          new_price += +(el.querySelector(".price-with-custom-currency").innerHTML.replace(/[^0-9]/g, ""))
        }
      });

      let cur = document.querySelector('.multi-picker__label').innerHTML;
      let p_price = Currency.convert(new_price, cur, cur) * 100;
      let u = Currency.money_format[cur] || "{{amount}}";
      let r = Currency.formatMoney(p_price, u);
      this.container.querySelectorAll('.product .price-with-custom-currency.price-item--regular').forEach(el=> el.innerHTML = r);
    }

  };
  setReferencePrice(){
    let current_price;
    let option_price;
    let current_cur = theme.settings.defaultShopCurrency;
    let custom_option_reference_price =  this.container.querySelectorAll('.custom-option.reference_option_price:not([data-price-type="fixed"])');
    if(custom_option_reference_price.length > 0){
      let cur_fabric = this.container.querySelector('.custom-option.fabric.selected');
      let category_button_price;
      let waistcoat_price;
      if(this.container.querySelector('.price-block .price').classList.contains('price--on-sale')){
        current_price = +this.container.querySelector('.price-block .price__sale .price-item--sale').getAttribute('data-price'.toLowerCase()).replace(/[^0-9]/g, "");
      }else{
        current_price = +this.container.querySelector('.price-block .price__regular .price-item--regular').getAttribute('data-price'.toLowerCase()).replace(/[^0-9]/g, "");
      }
      if(cur_fabric){
        let cur_fabric_price = +cur_fabric.getAttribute('data-price');
        current_price += cur_fabric_price;
      }
      custom_option_reference_price.forEach(option => {
        if(option.getAttribute("data-price-type") == 'waistcoat_reference_based'){
          if (current_price >= 1000) {
            option_price = Math.ceil((current_price * 0.2/5))*5;
          } else {
            option_price = Math.ceil((current_price * 0.3/5))*5;
          }
        }else if(option.getAttribute("data-price-type") == 'percentage_reference_based'){
          let option_percent = +option.getAttribute("data-reference-price");
          option_price = Math.ceil((current_price * (option_percent / 100)/5))*5;
        }
        let cur = document.querySelector('.multi-picker__label').innerHTML;
        let option_price_conv = Currency.convert(option_price, current_cur, cur) * 100;
        let u = Currency.money_format[cur] || "{{amount}}";
        var r = Currency.formatMoney(option_price_conv, u);
        if(option.getAttribute("data-price-type") == 'waistcoat_reference_based'){
          category_button_price = r;
          waistcoat_price = option_price;
        }
        let option_name = option.querySelector('.option-info').getAttribute("data-option-name");
        option.setAttribute('data-price', option_price);
        option.querySelector('.price-with-custom-currency').setAttribute('data-price', option_price);
        option.querySelector('.price-with-custom-currency').innerHTML = r;
        option.querySelector('.option-info').setAttribute('data-price', option_price);
        if(option_price > 0){
          option.querySelector('.option-info').value = option_name + " ($" + option_price + ")";
        }
      });

      if(this.container.querySelector('.category-button-price') && waistcoat_price){
        this.container.querySelector('.category-button-block .category-button-price').innerHTML = '<span class="price-with-custom-currency" data-price="'+waistcoat_price+'" data-currency="' + theme.settings.defaultShopCurrency + '">'+ category_button_price +'</span>';
      }
      let parent = findAncestor(custom_option_reference_price[0], 'option-block');
      if(parent.querySelector('.custom-option.selected .check-option')){
        parent.querySelector('.option-block-title .selected-variant').innerHTML = parent.querySelector('.custom-option.selected .check-option').innerHTML;
      }
    }
  }
  setParamValues(params){
    let paramsParts = params.split('&');
    let option_block = this.container.querySelector('.product_option_variants');
    let default_option = option_block.querySelectorAll('input[chacked]');
    let size_param = false;
    paramsParts.forEach(part => {
      if(part.indexOf("edit_measure") !== -1){
        let paramMeasure = part.split(":")[1];
        if(this.container.querySelector('.size-block .size-block-btn[data-content="'+ paramMeasure +'"]')){
          this.container.querySelector('.size-block').classList.add("selected");
          this.container.querySelector('.size-block .size-block-btn[data-content="'+ paramMeasure +'"]').classList.add("selected");
          this.container.querySelector('.content-type[data-content="'+ paramMeasure +'"]').querySelector('.measure-type').checked = true;
          this.container.querySelector('.content-type[data-content="'+ paramMeasure +'"]').classList.add("active");
        }
        if(paramMeasure == 'size-options'){
          size_param = true;
        }
      }else if (part.indexOf("options:") !== -1) {
        let paramOptions = part.replace('options:', '').split(";");
        paramOptions.forEach(option => {
          let option_name = option.split(":")[0];
          let option_val = option.split(":")[1];
          if(this.container.querySelector('[name="properties['+ option_name +']"]')){
            let prop_type = this.container.querySelector('[name="properties['+ option_name +']"]').getAttribute('type');
            if(prop_type == 'text'){
              let cur_option = this.container.querySelector('[name="properties['+ option_name +']"]');
              if(option_val != ''){
                cur_option.parentElement.querySelectorAll('.text-option-prop').forEach(el=>el.disabled = false);
                cur_option.parentElement.querySelectorAll('.text-option-prop').forEach(el=>el.value  = option_val);
                cur_option.parentElement.querySelector('.text-option').value  = option_val;
                cur_option.parentElement.querySelector('.text-option').disabled = false;
                if(findAncestor(cur_option.parentElement.querySelector('.text-option'), 'option_setOptions__optionsList__item')){
                  cur_option.parentElement.querySelector('.text-option').dispatchEvent(new Event("input"));
                  cur_option.parentElement.querySelector('.text-option').dispatchEvent(new Event("change"));
                }else{
                  cur_option.parentElement.querySelector('.text-option').dispatchEvent(new Event("change"));
                }
              }
            }else{
              if(!this.container.querySelector('input[value="'+ option_val +'"]').checked){
                let cur_option = document.querySelector('input[value="'+ option_val +'"]');
                let cur_option_parent = findAncestor (cur_option, 'custom-option');
                cur_option_parent.dispatchEvent(new Event("click"));
              }
            }
          }
        });

        if(document.querySelector('.category-button-block')){
          let container = document.querySelector('.category-button-block').parentElement;
          if(!container.querySelectorAll('.custom-option')[0].classList.contains('selected')){
            container.querySelector('.category-button-block').classList.remove('active');
            container.querySelector('.category-option-wrap').classList.add('active');
          }else{
            container.querySelector('.category-button-block').classList.add('active');
            container.querySelector('.category-option-wrap').classList.remove('active');
          }
        }
      }else if(part.indexOf("edit_id:") !== -1){
        const custom_id = document.createElement("div");
        custom_id.setAttribute('data-custom-id', part.split(":")[1]);
        custom_id.classList.add('old-product', 'hidden');
        this.container.querySelector('.product_option_variants').appendChild(custom_id);
      }
    })

    if(size_param){
      this.container.querySelectorAll('.size-type-popup .apply-button').forEach(tab => tab.dispatchEvent(new Event("click")));
    }
    this.container.querySelector('.customize-block-btn span').innerHTML = "Edit Customization";
    this.container.querySelector('.product-form__submit span').innerHTML = "Update";
    this.container.querySelector('.save-measure span').innerHTML = "Update";
    this.checkRequired();
  }
  showProgress(){
    document.querySelector('.page-loading-overlay').style.display = 'block';
  }
  hideProgress(){
    document.querySelector('.page-loading-overlay').style.display = 'none';
  }
  closePopup(){
    document.querySelector('.option-mask').classList.remove("active");
    this.bodyRemoveFixed();
    if(document.querySelector('.product__info-container--sticky')){
      document.querySelector('.product__info-container--sticky').classList.remove("not-sticky");
    }
  }

  scrollProductInfo(){
    let element = document.querySelector('.product__info-container--sticky');
    if (!element) {
      return;
    }
    let lastKnownY = window.scrollY;
    let currentTop = 0;
    let initialTopOffset = parseInt(window.getComputedStyle(element).top)

    window.addEventListener('scroll',(event) => {
      if(window.innerWidth >= 990 ){
        var bounds = element.getBoundingClientRect(),
          maxTop = bounds.top + window.scrollY - element.offsetTop + initialTopOffset,
          minTop = element.clientHeight - window.innerHeight;

        if (window.scrollY < lastKnownY) {
          currentTop -= window.scrollY - lastKnownY;
        } else {
          currentTop += lastKnownY - window.scrollY;
        }

        currentTop = Math.min(Math.max(currentTop, -minTop), maxTop, initialTopOffset);
        lastKnownY = window.scrollY;
        element.style.top = currentTop + 'px';
      }
    });
  }
  stickyBtn(){
    window.addEventListener('scroll',(event) => {
      let productAddBtn = document.querySelector('.product-form__submit');
      let productAddBtnMask = document.querySelector('.product-form__buttons .button-mask');
      let productAddBtnHeight = productAddBtn.offsetHeight;
      productAddBtnHeight += parseInt(window.getComputedStyle(productAddBtn).getPropertyValue('margin-top'));
      productAddBtnHeight += parseInt(window.getComputedStyle(productAddBtn).getPropertyValue('margin-bottom'));
      productAddBtnMask.style.height = productAddBtnHeight + 'px';
      let productAddBtnParent = findAncestor(productAddBtn, 'product-form__buttons');
      if(productAddBtn && productAddBtnParent){
        if(window.innerWidth < 990 ){
          if (window.scrollY > productAddBtn.parentElement.offsetTop) {
            if(document.querySelector('.sticky-header')){
              productAddBtn.style.top = (document.querySelector('.header-wrapper').offsetHeight - 1) + 'px';
              productAddBtnMask.style.top = (document.querySelector('.header-wrapper').offsetHeight - 1) + 'px';
            }
            productAddBtnParent.classList.add('fixed');
            productAddBtnParent.style.paddingBottom = productAddBtn.offsetHeight + 'px'
          } else {
            productAddBtn.style.top = '0px';
            productAddBtnMask.style.top = '0px';
            productAddBtnParent.style.paddingBottom = '0px';
            productAddBtnParent.classList.remove('fixed');
          }
        }else{
          productAddBtn.style.top = '0px';
          productAddBtnMask.style.top = '0px';
          productAddBtnParent.style.paddingBottom = '0px';
          productAddBtnParent.classList.remove('fixed');
        }
      }
    })
  }
}
class UpsellOptions extends CustomOptions {
  constructor() {
    super();
    this.container = this;
  }
}
  function findAncestor (el, cls) {
  while ((el = el.parentElement) && !el.classList.contains(cls));
  return el;
}

document.addEventListener('click', e => {
  if (window.innerWidth > 989){
    let target = e.target;
    let filter = document.querySelector('.filter-field.active');
    if(filter){
      let its_filter = target == filter || filter.contains(target);
      if (!its_filter) {
        filter.classList.remove("active");
      }
    }
  }

});

fabricFilter = {
  coords: [],
  itemAttrs: [],
  eventHandles: [],
  origAttrStats: {},
  filterMappings: {},
  matched: '',
  init: function(container) {
    fabricFilter.container = $("#"+container);
    fabricFilter.itemList = fabricFilter.container.find('.color-block-content');
    fabricFilter.filterWrap = fabricFilter.container.find('.filters');
    fabricFilter.attrGroups = fabricFilter.filterWrap.find('.filters-content');
    fabricFilter.placeholder = fabricFilter.filterWrap.find('.filter-title');
    fabricFilter.keys = fabricFilter.filterWrap.find('.filter-key');
    fabricFilter.sorts = fabricFilter.filterWrap.find('.sort-value');
    fabricFilter.clear = fabricFilter.filterWrap.find('.filt-clear');
    fabricFilter.filtersInited = false;
    fabricFilter.filtersFixed = false;
    fabricFilter.filtersExpanded = false;
    fabricFilter.initEvents();
    if (fabricFilter.keys.hasClass('selected')) {
      fabricFilter.initFilters();
    }
  },
  destruct: function() {
    for (var i = 0, j = fabricFilter.eventHandles.length; i < j; i++) {
      fabricFilter.eventHandles[i].unbind();
      fabricFilter.eventHandles[i] = null;
    }
    fabricFilter.coords = fabricFilter.itemAttrs = fabricFilter.eventHandles = fabricFilter.origAttrStats = fabricFilter.filterMappings = fabricFilter.tS = fabricFilter.viewportWidth = fabricFilter.layoutCon = fabricFilter.itemList = fabricFilter.filterWrap = fabricFilter.attrGroups = fabricFilter.placeholder = fabricFilter.keys = fabricFilter.has3dTransforms = fabricFilter.sortPrice = fabricFilter.items = fabricFilter.itemSize = fabricFilter.matched = fabricFilter.unmatched = fabricFilter.filtersInited = fabricFilter.filtersFixed = fabricFilter.filtersExpanded = null;
  },
  initFilters: function() {
    fabricFilter.sortPrice = fabricFilter.filterWrap.find('.filt-price-input');
    fabricFilter.items = fabricFilter.itemList.find('.custom-option');
    fabricFilter.showAll = true;
    fabricFilter.initItemAttrs();
    fabricFilter.initFilterMapping();
    fabricFilter.filtersInited = true;
  },
  initEvents: function() {
    fabricFilter.eventHandles[fabricFilter.eventHandles.length] = fabricFilter.placeholder.bind('click', fabricFilter.showFilterDropdown);
    fabricFilter.eventHandles[fabricFilter.eventHandles.length] = fabricFilter.clear.bind('click', fabricFilter.resetFilters);
    fabricFilter.eventHandles[fabricFilter.eventHandles.length] = fabricFilter.keys.bind('click', function() {
      if ($(this).hasClass('selected')) {
        $(this).removeClass('selected');
      }else{
        $(this).addClass('selected');
      }
      let f_count = $(this).closest(".filters-content").find('.filter-key.selected').length;
      if(f_count > 0){
        $(this).closest(".filter-field").find('.filter-count').text("("+ f_count +")");
      }else{
        $(this).closest(".filter-field").find('.filter-count').text("");
      }
      fabricFilter.filterAndDisplay();
    });
    fabricFilter.eventHandles[fabricFilter.eventHandles.length] = fabricFilter.sorts.bind('click', function(e) {
      e.preventDefault();
      fabricFilter.sorts.removeClass('selected');
      let date_type = $(this).data('value');
      fabricFilter.container.find('.sort-value[data-value="'+ date_type +'"]').addClass('selected');
      fabricFilter.sortFilter(date_type);
      fabricFilter.initFilters();
      fabricFilter.filterAndDisplay();
      //initOptions();
    });
  },
  initItemAttrs: function() {
    fabricFilter.items.each(function(index) {
      var attributes = [];
      if ($(this).attr('data-filtr-attrs')) {
        attributes = $(this).attr('data-filtr-attrs').split(';');
      }
      fabricFilter.itemAttrs[index] = attributes;
      fabricFilter.initAttrStats(attributes);
    });
  },
  initAttrStats: function(attr) {
    for (var i = 0, j = attr.length; i < j; i++) {
      fabricFilter.origAttrStats[attr[i]] = fabricFilter.origAttrStats[attr[i]] || 0;
      fabricFilter.origAttrStats[attr[i]]++;
    }
  },
  initFilterMapping: function() {
    fabricFilter.container.find('.filt-item').each(function(i) {
      $(this).find('li').each(function(j) {
        var attr = $(this).attr('data-value');
        fabricFilter.filterMappings[attr] = i;
      });
    });
  },
  showFilterDropdown: function() {
    var selectCon;
    if (!fabricFilter.filtersInited) {
      fabricFilter.initFilters();
    }
    selectCon = $(this);
    if (selectCon.parent().hasClass('active')) {
      fabricFilter.hideFilterDropdown();
    } else {
      fabricFilter.hideFilterDropdown();
      selectCon.parent().addClass('active');
    }
  },
  hideFilterDropdown: function() {
    fabricFilter.filterWrap.find('.filter-field').removeClass('active');
  },
  togglePriceInputs: function(e) {
    fabricFilter.sortPrice.filter(':checked').each(function(input) {
      if (input !== e.target) {
        input.set('checked', false);
      }
    });
    fabricFilter.hideFilterDropdown();
    fabricFilter.filterAndDisplay();
  },
  onviewevent: function(e) {
    if (e.target.hasClass('option-filt-clear')) {
      fabricFilter.resetFilters();
      e.preventDefault();
      return false;
    }
    if (!e.target.ancestor('.filt-select-con')) {
      fabricFilter.hideFilterDropdown();
    }
  },
  sortFilter: function (type){
    if(type == 'default'){
      fabricFilter.items.sort(function(a,b) { return parseFloat(a.dataset.index) - parseFloat(b.dataset.index) } );
    }else if(type == 'new'){
      fabricFilter.items.sort(function(a,b) { return parseFloat(b.dataset.date) - parseFloat(a.dataset.date) } );
    }
    fabricFilter.container.find('.color-block-content .option-block').html(fabricFilter.items);
  },
  filterAndDisplay: function() {
    var selectedArr = fabricFilter.parseFilters(),
      sortOrder;
    if (fabricFilter.showAll) {
      fabricFilter.resetItems();
    } else {
      fabricFilter.filterItems(selectedArr);
    }
    fabricFilter.hideItems(fabricFilter.unmatched);
    fabricFilter.displayItems(fabricFilter.matched);
    if (!fabricFilter.matched.length) {
      fabricFilter.showEmptyState();
    } else {
      fabricFilter.hideEmptyState();
    }
    fabricFilter.hideFilterDropdown();
    let filtered_item = fabricFilter.matched.length;
    if(filtered_item > 0){
      filtered_item = "See " + filtered_item;
    }
    fabricFilter.container.find('.filters-result-numb').empty().append(filtered_item);
    fabricFilter.container.find('.filters-result').addClass('active');
    let f_all_count = fabricFilter.container.find('.filter-key.selected').length;
    if(f_all_count > 0){
      fabricFilter.container.find('.filters-wrap-btn-numb').text("("+ f_all_count +")");
    }else{
      fabricFilter.container.find('.filters-wrap-btn-numb').text("");
    }
    fabricFilter.container.find('.loading-overlay').hide();
  },
  resetFilters: function() {
    fabricFilter.attrGroups.each(function(i) {
      $(this).find('.filter-key').removeClass('selected');
    });
    fabricFilter.container.find('.filter-count').text("");
    fabricFilter.filterAndDisplay();
  },
  resetItems: function() {
    fabricFilter.matched = [];
    fabricFilter.unmatched = [];
    fabricFilter.items.each(function() {
      fabricFilter.matched.push($(this));
    });
  },
  filterItems: function(selectedArr) {
    var attrStats = $.extend(true, [], fabricFilter.origAttrStats),
      attrs;
    fabricFilter.matched = [];
    fabricFilter.unmatched = [];
    fabricFilter.items.each(function(i) {
      attrs = fabricFilter.itemAttrs[i];
      if (fabricFilter.filterAcrossGroups(attrs, selectedArr)) {
        fabricFilter.matched.push($(this));
      } else {
        fabricFilter.unmatched.push($(this));
      }
    });
  },
  filterAcrossGroups: function(attrs, selected) {
    var numMatched = 0;
    for (var i = 0, j = selected.length; i < j; i++) {
      if (fabricFilter.checkAnyMatch(attrs, selected[i])) {
        numMatched++;
      }
    }
    return numMatched === selected.length;
  },
  checkAnyMatch: function(attrs, selected) {
    for (var i = 0, j = selected.length; i < j; i++) {
      if (attrs.join(' ').indexOf(selected[i]) !== -1) {
        return true;
      }
    }
    return false;
  },
  parseFilters: function() {
    var matched = [],
      selected;
    fabricFilter.showAll = true;
    fabricFilter.attrGroups.each(function(i) {
      selectedAttr = [];
      selected = $(this).find('.filter-key.selected');
      if (selected.length) {
        if ($(this).attr('data-filter-type') !== 'price') {
          fabricFilter.showAll = false;
          selected.each(function(i) {
            selectedAttr.push($(this).attr('data-value'));
          });
          matched.push(selectedAttr);
        }
      }
    });
    return matched;
  },
  sortByPrice: function(items, sortOrder) {
    sortOrder = sortOrder || 'ascending';
    items.sort(function(a, b) {
      var aPrice = a.attr('data-price'),
        bPrice = b.attr('data-price');
      if (aPrice && bPrice) {
        if (sortOrder === 'ascending') {
          return aPrice - bPrice;
        } else {
          return bPrice - aPrice;
        }
      }
    });
    return items;
  },
  updateAttributeStats: function(selectedArr, attrStats) {
    var reset = {},
      flatSelected = [].concat.apply([], selectedArr);
    for (var i = 0; i < fabricFilter.itemAttrs.length; i++) {
      var selected = [];
      for (var j = 0; j < fabricFilter.itemAttrs[i].length; j++) {
        for (var k = 0; k < flatSelected.length; k++) {
          if (fabricFilter.itemAttrs[i][j] === flatSelected[k]) {
            selected.push(j);
          }
        }
      }
      if (selected.length) {
        for (var attr in attrStats) {
          if (attrStats.hasOwnProperty(attr)) {
            for (var l = 0; l < selected.length; l++) {
              if (!reset[attr] && (fabricFilter.filterMappings[fabricFilter.itemAttrs[i][selected[l]]] !== fabricFilter.filterMappings[attr])) {
                attrStats[attr] = 0;
                reset[attr] = true;
              }
            }
          }
        }
        for (var j = 0, jlen = fabricFilter.itemAttrs[i].length; j < jlen; j++) {
          attrStats[fabricFilter.itemAttrs[i][j]]++;
        }
      }
    }
    return attrStats;
  },
  checkSingleFilter: function() {
    var selectedArr = fabricFilter.parseFilters(),
      selectedArrSize = selectedArr.length;
    if (selectedArrSize === 1) {
      return fabricFilter.filterMappings[selectedArr[0][0]];
    }
    return -1;
  },
  isSelected: function(key, selectedArrFlat) {
    return (selectedArrFlat.indexOf(key) !== -1);
  },
  isInSingleDropdown: function(key, column) {
    if (column !== -1) {
      if (fabricFilter.filterMappings[key] === column) {
        return true;
      }
    }
    return false;
  },
  ieStyleSelections: function() {
    var remove;
    fabricFilter.keys.each(function(item) {
      remove = item.next('.filt-item-label').one('.icon-remove-item');
      if (item.get('checked')) {
        remove.css('display', 'block');
      } else {
        remove.css('display', 'none');
      }
    });
  },
  displayItems: function(items) {
    var x, y;
    for (var i = 0, j = items.length; i < j; i++) {
      fabricFilter.displayItem(items[i]);
    }
  },
  displayItem: function(item) {
    if (fabricFilter.filtersInited && !item.hasClass('list-item-move')) {
      item.addClass('list-item-move');
    }
    item.css('display', 'block');
  },
  hideItems: function(items) {
    var transformStyle, x, y, pos;
    for (var i = 0, j = items.length; i < j; i++) {
      fabricFilter.hideItem(items[i]);
    }
  },
  hideItem: function(item) {
    item.css('display', 'none');
  },
  showEmptyState: function() {
    var selectedArr = fabricFilter.parseFilters(),
      emptyState = $('#filt-emptystate'),
      emptyStr = '';
    for (var i = 0; i < selectedArr.length; i++) {
      if (selectedArr[i].length > 1) {
        emptyStr += selectedArr[i].slice(0, selectedArr[i].length - 1).join(', ');
        emptyStr += ' and ' + selectedArr[i][selectedArr[i].length - 1];
      } else if (selectedArr[i].length) {
        emptyStr += selectedArr[i][0];
      }
      if (i < selectedArr.length - 1) {
        emptyStr += ', ';
      }
    }
    emptyState.find('.filt-emptystate-selectedfilters').html(emptyStr);
    emptyState.removeClass('hide');
    fabricFilter.container.find('.color-block .apply-button').addClass('hide');
  },
  hideEmptyState: function() {
    fabricFilter.container.find('#filt-emptystate').addClass('hide');
    fabricFilter.container.find('.color-block .apply-button').removeClass('hide');
  }
};

window.addEventListener('mouseup', e => {
  let option_popups = document.querySelectorAll(".option-popup");

  if(option_popups){
    option_popups.forEach(popup => {
      if(popup && popup.classList.contains('active')){
        if (e.target != popup && !findAncestor(e.target, "option-popup")) {
          popup.classList.remove('active');
          if(!popup.classList.contains('size-type-popup') && !document.querySelector('.quick-add-popup.active')){
            document.querySelector('custom-options').closePopup();
          }else if(!popup.classList.contains('size-type-popup') && document.querySelector('.quick-add-popup.active')){
            document.querySelector('.option-mask').classList.remove("active");
          }
        }
      }
    });
  }

  let size_popups = document.querySelectorAll(".size-chart-table");
  if(size_popups){
    size_popups.forEach(popup => {
      if(popup && popup.classList.contains('active')){
        if (e.target != popup && !findAncestor(e.target, "size-chart-table") ) {
          document.querySelector('.size-chart--mask').classList.remove("active");
          popup.classList.remove('active');
          if(!document.querySelector('.quick-add-popup.active')){
            let bodyScrollY = parseInt(document.body.style.getPropertyValue('top'), 10);
            bodyScrollY = Math.abs(bodyScrollY);
            document.body.classList.remove("fixed");
            document.body.style.top = null;
            window.scrollTo(0, bodyScrollY);
          }
        }
      }
    });
  }
});